module.exports = __webpack_public_path__ + "static/media/work-img1.cfb82080.jpg";